module.exports = __webpack_public_path__ + "static/img/case_detail_12_2.0faef29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_12_2.png
// module id = bTGU
// module chunks = 34